$(document).ready(function () {
  $('.shopify-payment-button').on('click', function (e) {
    e.preventDefault();

    if (window.ShopifyAnalytics) {
      Shopify.analytics.publish('analytics:trackEvent', {
        name: 'buy_with_shoppay',
        payload: {
          variantId: window.ShopifyAnalytics.meta.selectedVariantId
        }
      });
    }
  });
});

// UserWay footer trigger: stays hidden until the widget is ready (consent, ad blockers)
(function () {
  function enableUserWayTriggers(userWay) {
    document.querySelectorAll('.userway-trigger').forEach((trigger) => {
      trigger.hidden = false;
      trigger.addEventListener('click', () => userWay.widgetOpen());
    });
  }

  if (window.UserWay && typeof window.UserWay.widgetOpen === 'function') {
    enableUserWayTriggers(window.UserWay);
  } else {
    document.addEventListener(
      'userway:init_completed',
      (event) => enableUserWayTriggers((event.detail && event.detail.userWayInstance) || window.UserWay),
      { once: true }
    );
  }
})();
